import actions from './actions'
import getters from './getters'
import mutations from './mutations'

const state = {
  pointitem: {},
  errorpoint: false,
  isLoadingpoint: false,

  pointHistoryitem: [],
  errorpointHistory: false,
  isLoadingpointHistory: false,

  pointVoucher: [],
  errorpointVoucher: false,
  isLoadingpointVoucher: false,

  redeemPoint: {},
  errorredeemPoint: false,
  isLoadingredeemPoint: false,

  itemLeaderboard: {},
  errorLeaderboard: false,
  isLoadingLeaderboard: false
}

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/andalinpoint/index.js